<!-- results-table.component.html -->
<h1 mat-dialog-title>Modificar estado del link relacionado</h1>
<div mat-dialog-content >

    <mat-form-field appearance="fill">
        <mat-label>Estado</mat-label>
        <mat-select [(ngModel)]="estado" name="estado" required>
            <mat-option *ngFor="let tipo of estados" [value]="tipo.value">
                {{tipo.nombre}}
            </mat-option>
        </mat-select>
    </mat-form-field>


<div mat-dialog-actions >
  <button mat-button (click)="modificarEstado()"
  >{{'Modificar' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
